import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { getUnreadMessageCount } from '../../actions/messaging';
import { fetchCurrentMember, logout } from '../../actions/user';

import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SubscriptionExpiryMessage from '../../components/SubscriptionExpiryMessage';
import Toast from '../../components/Toast';
import { ROUTES } from '../../config/routes';
import { Theme } from '../../config/theme';

let styles;

class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
    };
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
    this.renderSubscriptionExpiryMessage = this.renderSubscriptionExpiryMessage.bind(this);

    this.notificationTimer = null;
  }

  componentWillMount() {
    if (!this.props.user.isAuthenticated && !this.props.allowUnauthenticated) {
      this.setState({
        loggedIn: true,
      });
      this.props.history.push('/');
      this.props.dispatch(
        updateAppState({
          login_modal_open: true,
        }),
      );
    } else if (this.props.user.isAuthenticated) {
      // User is logged in
      // Fetch initial unread count
      this.props.dispatch(getUnreadMessageCount(this.props.user.access_token));

      this.notificationTimer = setInterval(() => {
        this.props.dispatch(fetchCurrentMember(this.props.user.id, this.props.user.access_token));
        this.props.dispatch(getUnreadMessageCount(this.props.user.access_token));
      }, 30000);
    } else {
      // User is not logged in, but authentication is not required in this route
    }
  }

  componentWillUnmount() {
    clearInterval(this.notificationTimer);
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  /**
   * Display a message if the user has no active subscription.
   * @return {*}
   */
  renderSubscriptionExpiryMessage() {
    const {
      match: { path: URL_PATH },
      user: { active_subscription: ACTIVE_SUBSCRIPTION },
    } = this.props;

    /**
     * If the user has an active subscription,
     * or they're on the membership page don't
     * display the message.
     */
    if (ACTIVE_SUBSCRIPTION || URL_PATH === ROUTES.SETTINGS.MEMBERSHIP) {
      return null;
    }

    return (
      <Toast>
        <SubscriptionExpiryMessage />
      </Toast>
    );
  }

  render() {
    return (
      <Body>
        <DashboardHeader
          logoutHandler={this.logoutHandler}
          redirectHandler={this.redirectHandler}
          {...this.props}
        />
        <div
          className={css(this.props.hideFooter ? styles.containerWithoutFooter : styles.container)}
        >
          {this.props.children}
        </div>
        {!this.props.hideFooter && <Footer user={this.props.user} />}
        {this.renderSubscriptionExpiryMessage()}
      </Body>
    );
  }
}

styles = StyleSheet.create({
  container: {
    paddingTop: 50,
    paddingBottom: 150,
    [Theme.mobile_query]: {
      paddingBottom: 0,
    },
  },
  containerWithoutFooter: {
    paddingTop: 50,
    paddingBottom: 0,
    [Theme.mobile_query]: {
      paddingBottom: 0,
    },
  },
});

DashboardContainer.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  match: PropTypes.shape.isRequired,
  allowUnauthenticated: PropTypes.bool,
  hideFooter: PropTypes.bool,
};

DashboardContainer.defaultProps = {
  allowUnauthenticated: false,
  hideFooter: false,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardContainer));



// WEBPACK FOOTER //
// ./src/views/DashboardContainer/index.js